import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "simplifiedBox" }
const _hoisted_2 = { class: "simplifiedTitle" }
const _hoisted_3 = { class: "simplifiedBtn" }
const _hoisted_4 = { class: "btnBox" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'simplified',
  emits: ['closeThis','simplifiedFun'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
const handleClose = () => {
    // console.log(tolanguage.value)
    emit('simplifiedFun')
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "简繁转换", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(closeBox, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "simplifiedPrompt" }, " 简繁转化仅针对原文文字本身，不包含词组的固定转换 ", -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "btnNo",
          onClick: _withModifiers(closeBox, ["stop"])
        }, "取消"),
        _createElementVNode("span", {
          class: "btnOk",
          onClick: _withModifiers(handleClose, ["stop"])
        }, "确定")
      ])
    ])
  ]))
}
}

})